module.exports = __webpack_public_path__ + "static/media/deutscher.4a8ea8c8.svg";